"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ioTsPrimitiveInterpreter = exports.BigIntString = void 0;
var utils_1 = require("@morphic-ts/common/lib/utils");
var Either_1 = require("fp-ts/Either");
var function_1 = require("fp-ts/lib/function");
var t = require("io-ts");
var DateFromISOString_1 = require("io-ts-types/lib/DateFromISOString");
var either_1 = require("io-ts-types/lib/either");
var option_1 = require("io-ts-types/lib/option");
var optionFromNullable_1 = require("io-ts-types/lib/optionFromNullable");
var readonlyNonEmptyArray_1 = require("io-ts-types/lib/readonlyNonEmptyArray");
var UUID_1 = require("io-ts-types/lib/UUID");
var config_1 = require("../config");
var hkt_1 = require("../hkt");
/**
 *  @since 0.0.1
 */
exports.BigIntString = new t.Type('BigIntString', 
// tslint:disable-next-line: strict-type-predicates valid-typeof
function (u) { return u !== undefined && u !== null && typeof u === 'bigint'; }, function (u, c) {
    return Either_1.either.chain(t.string.validate(u, c), function (s) {
        try {
            var d = BigInt(s);
            return t.success(d);
        }
        catch (_b) {
            return t.failure(u, c);
        }
    });
}, function (a) { return a.toString(10); });
var tag = function (s) {
    return new t.Type(s, function (u) { return u === s; }, function (_i, _c) { return t.success(s); }, function (_a) { return undefined; });
};
/**
 *  @since 0.0.1
 */
/* istanbul ignore next */
exports.ioTsPrimitiveInterpreter = utils_1.memo(function () { return ({
    _F: hkt_1.IoTsURI,
    date: function (config) { return function (env) { return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(DateFromISOString_1.DateFromISOString, env, {})); }; },
    boolean: function (config) { return function (env) { return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(t.boolean, env, {})); }; },
    string: function (config) { return function (env) { return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(t.string, env, {})); }; },
    number: function (config) { return function (env) { return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(t.number, env, {})); }; },
    bigint: function (config) { return function (env) { return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(exports.BigIntString, env, {})); }; },
    stringLiteral: function (l, config) { return function (env) { return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(t.literal(l, l), env, {})); }; },
    numberLiteral: function (l, config) { return function (env) { return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(t.literal(l, "" + l), env, {})); }; },
    oneOfLiterals: function (l, config) { return function (env) {
        return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(t.union(l.map(function (_) { return t.literal(_); })), env, {}));
    }; },
    // oneOfLiterals: (l, config) => env => new IOTSType(iotsApplyConfig(config)(t.keyof(makeObj(l)), env, {})),
    tag: function (l, config) { return function (env) { return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(tag(l), env, {})); }; },
    keysOf: function (k, config) { return function (env) {
        return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(t.keyof(k), env, {}));
    }; },
    nullable: function (T, config) { return function (env) {
        return function_1.pipe(T(env).type, function (type) { return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(optionFromNullable_1.optionFromNullable(type), env, { type: type })); });
    }; },
    optional: function (T, config) { return function (env) {
        return function_1.pipe(T(env).type, function (type) { return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(t.union([type, t.undefined]), env, { type: type })); });
    }; },
    mutable: function (T, config) { return function (env) {
        return function_1.pipe(T(env).type, function (type) { return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(type, env, { type: type })); });
    }; },
    array: function (T, config) { return function (env) {
        return function_1.pipe(T(env).type, function (type) { return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(t.readonlyArray(type), env, { type: type })); });
    }; },
    nonEmptyArray: function (T, config) { return function (env) {
        return function_1.pipe(T(env).type, function (type) { return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(readonlyNonEmptyArray_1.readonlyNonEmptyArray(type), env, { type: type })); });
    }; },
    uuid: function (config) { return function (env) { return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(UUID_1.UUID, env, {})); }; },
    either: function (e, a, config) { return function (env) {
        return (function (left, right) { return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(either_1.either(left, right), env, { left: left, right: right })); })(e(env).type, a(env).type);
    }; },
    option: function (T, config) { return function (env) {
        return function_1.pipe(T(env).type, function (type) { return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(option_1.option(type), env, { type: type })); });
    }; },
    unknownE: function (a, config) { return function (env) { return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(a(env).type, env, {})); }; }
}); });
